<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <section class="contact-hero-section" :style="{ backgroundImage: `url(${heroImage})` }">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="hero-content animate-on-scroll fade-in-up">
              <h1 class="hero-title">Detalles de contacto</h1>
              <h2 class="hero-subtitle">¡Nos encantaría ayudar!</h2>
              <p class="hero-description">
                Envíanos un mensaje y uno de nuestros agentes se comunicará contigo lo antes posible.
              </p>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- Espacio para la imagen (se ve en el fondo) -->
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Info Section -->
    <ContactInfoSection />

    <!-- Contact Form Section -->
    <section class="contact-form-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <div class="section-header text-center mb-5 animate-on-scroll fade-in-up">
              <h2 class="section-title">¿Necesitas más información?</h2>
            </div>
            <div class="contact-form-wrapper animate-on-scroll fade-in-up" style="animation-delay: 0.1s">
              <ContactFormCard form-id="contact-page" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Service Area Section -->
    <ServiceAreasSection 
      :locations="locations" 
      :google-maps-url="googleMapsUrl"
    />

    <!-- Statistics Section -->
    <StatisticsSection
      members="500+"
      years="3+"
      :locations="locations"
      :satisfaction="99"
      variant="light"
    />

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 mx-auto text-center">
            <div class="cta-content animate-on-scroll fade-in-up">
              <h2 class="cta-title">Tu salud y la de tu familia es lo más importante</h2>
              <p class="cta-subtitle">
                Únete hoy a Hispano Medical Plan y comienza a disfrutar de atención médica de calidad a un precio accesible. Miles de familias ya confían en nosotros para proteger lo más valioso: su salud y bienestar.
              </p>
              <div class="cta-buttons">
                <router-link to="/plans" class="btn btn-cta-primary btn-lg">
                  ¡Hazte Miembro!
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Section -->
    <TestimonialsSection :testimonials="testimonials" :locations="locations" />
  </div>
</template>

<script>
import { ServiceAreasSection, ContactInfoSection, StatisticsSection, TestimonialsSection, ContactFormCard } from '../components'

export default {
  name: 'Contact',
  components: {
    ServiceAreasSection,
    ContactInfoSection,
    StatisticsSection,
    TestimonialsSection,
    ContactFormCard
  },
  data() {
    return {
      heroImage: require('@/assets/lp/6c.png'),
      scrollObserver: null,
      visibleElements: new Set(),
      googleMapsUrl: 'https://www.google.com/maps/@32.8915449,-96.9087889,11z/data=!4m2!11m1!2sXs5WthpeGtow6ZlL-JWYW8hYJXOD_A?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D',
      testimonials: [
        { text: "Antes de Hispano Medical Plan, cada visita al médico era un estrés financiero. Ahora llevo a mis tres hijos cuando lo necesitan, sin preocuparme por copagos. El personal es increíble, siempre nos atienden en español y con tanto cariño. Es como tener un médico de familia, pero mejor.", author: "" },
        { text: "Mi medicamento para la diabetes costaba $180 al mes. Con Hispano Medical Plan ahora pago solo $35. Eso son $1,740 de ahorro al año. Pero más que el dinero, es la tranquilidad de saber que puedo seguir mi tratamiento sin sacrificar otras necesidades de mi familia. Esto cambió mi vida.", author: "" },
        { text: "Trabajo dos turnos y no tenía tiempo para ir al médico. Con la telemedicina de Hispano Medical Plan, consulté a las 10 PM desde mi casa cuando mi hija tenía fiebre. El doctor me dio la receta y al día siguiente ya tenía los medicamentos. Sin perder trabajo, sin salir de casa. Esto es lo que necesitaba mi familia.", author: "" }
      ],
      locations: [
        {
          name: 'Oak Cliff',
          address: '3434 W Illinois Ave Ste 202, Dallas, Texas, 75211',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'First Street Garland',
          address: '3050 S. First St, Garland, Texas, 75041',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Fort Worth',
          address: '1303 N Beach St, Fort Worth, Texas, 76111',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Garland',
          address: '3516 W Walnut St, Garland, Texas, 75042',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Buckner Blvd Dallas',
          address: '3045 N Buckner Blvd Suite 110, Dallas, Texas, 75228',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Coit',
          address: '14211 Coit Rd, Dallas, Texas, 75254',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Denton',
          address: '231 W University Dr #111, Denton, Texas, 76201',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Irving',
          address: '204 S Nursery Rd #166, Irving, Texas, 75060',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'Josey Lane',
          address: '3065 N Josey Ln Apt 28, Carrollton, Texas, 75007',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        },
        {
          name: 'McKinney',
          address: '811 N McDonald St, McKinney, Texas, 75069',
          phone: '+12148889000',
          email: 'info@tuclinicahispanafamiliar.com',
          hours: '09:00 AM - 10:00 PM',
          days: 'Mon, Tues, Wed, Thur, Fri, Sat, Sun'
        }
      ]
    }
  },
  mounted() {
    this.setupScrollAnimations()
  },
  beforeDestroy() {
    if (this.scrollObserver) {
      this.scrollObserver.disconnect()
    }
  },
  methods: {
    setupScrollAnimations() {
      const observerOptions = {
        threshold: 0.15,
        rootMargin: '0px 0px -80px 0px'
      }

      if (!this.scrollObserver) {
        this.scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // Activar animación cuando el elemento entra en el viewport
            if (entry.isIntersecting) {
              requestAnimationFrame(() => {
                entry.target.classList.add('is-visible')
                this.visibleElements.add(entry.target)
              })
            } else {
              // Remover la clase cuando sale del viewport para que se repita la animación
              requestAnimationFrame(() => {
                entry.target.classList.remove('is-visible')
                this.visibleElements.delete(entry.target)
              })
            }
          })
        }, observerOptions)
      }

      const initObserver = () => {
        const elements = this.$el.querySelectorAll('.animate-on-scroll')
        elements.forEach((el) => {
          // Asegurar que todos los elementos empiecen sin la clase visible
          el.classList.remove('is-visible')
          // Observar cada elemento para que se animen cuando entren al viewport
          this.scrollObserver.observe(el)
        })
      }

      this.$nextTick(() => {
        initObserver()
        
        // Verificar elementos que ya están visibles al cargar
        const elements = this.$el.querySelectorAll('.animate-on-scroll')
        elements.forEach(el => {
          const rect = el.getBoundingClientRect()
          const isInViewport = rect.top < window.innerHeight * 0.9 && rect.bottom > 0
          if (isInViewport) {
            setTimeout(() => {
              el.classList.add('is-visible')
              this.visibleElements.add(el)
            }, 100)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// Importar variables de color centralizadas
@import '../styles/variables';

.contact-page {
  min-height: 100vh;
  
  // Hero Section
  .contact-hero-section {
    padding: 140px 0 100px;
    background: $primary-gradient;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    color: white;
    
    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 60%;
      height: 100%;
      background: linear-gradient(to right, 
        rgba(45, 106, 110, 0.9) 0%, 
        rgba(34, 207, 224, 0.8) 40%, 
        rgba(45, 106, 110, 0.5) 70%, 
        transparent 100%);
      z-index: 1;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba(45, 106, 110, 0.2) 0%, transparent 50%, rgba(45, 106, 110, 0.2) 100%);
        z-index: 2;
      }
      
      @media (max-width: 991px) {
        width: 80%;
      }
      
      @media (max-width: 768px) {
        width: 100%;
        background: linear-gradient(to right, 
          rgba(45, 106, 110, 0.85) 0%, 
          rgba(34, 207, 224, 0.7) 50%, 
          rgba(45, 106, 110, 0.6) 100%);
      }
    }
    
    .container {
      position: relative;
      z-index: 2;
    }
    
    .hero-content {
      position: relative;
      z-index: 3;
      max-width: 600px;
      margin: 0;
      padding-right: 30px;
      
      .hero-title {
        font-size: 4.5rem;
        font-weight: 700;
        margin-bottom: 2rem;
        color: white;
        text-shadow: 0 3px 10px rgba(45, 106, 110, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1);
        letter-spacing: 2px;
        line-height: 1.2;
      }
      
      .hero-subtitle {
        font-size: 2.5rem;
        font-weight: 600;
        margin-bottom: 2rem;
        color: white;
        text-shadow: 0 2px 6px rgba(45, 106, 110, 0.2), 0 1px 3px rgba(0, 0, 0, 0.1);
      }
      
      .hero-description {
        font-size: 1.4rem;
        color: rgba(255, 255, 255, 0.95);
        max-width: 600px;
        margin: 0;
        line-height: 1.8;
        font-weight: 400;
        text-shadow: 0 1px 4px rgba(45, 106, 110, 0.15);
      }
    }
  }
  
  // Contact Details Section
  .contact-details-section {
    padding: 100px 0;
    background: $bg-light;
    
    .contact-detail-card {
      background: $bg-white;
      border-radius: 20px;
      padding: 3rem 2.5rem;
      text-align: center;
      box-shadow: 0 8px 30px rgba(45, 106, 110, 0.1);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      border: 3px solid $border-light;
      height: 100%;
      
      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 45px rgba(45, 106, 110, 0.25);
        border-color: $primary-color;
      }
      
      .contact-icon {
        width: 100px;
        height: 100px;
        background: $primary-gradient;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 2rem;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 8px 25px rgba(45, 106, 110, 0.3);
        
        i {
          font-size: 2.5rem;
          color: white;
        }
      }
      
      &:hover .contact-icon {
        transform: scale(1.15) rotate(5deg);
        box-shadow: 0 12px 35px rgba(45, 106, 110, 0.4);
      }
      
      .contact-label {
        font-size: 1.4rem;
        font-weight: 700;
        color: $primary-color;
        margin-bottom: 1rem;
        letter-spacing: 0.3px;
      }
      
      .contact-value {
        font-size: 1.3rem;
        color: $text-dark;
        margin: 0.5rem 0;
        font-weight: 600;
        line-height: 1.6;
      }
    }
  }
  
  // Contact Form Section
  .contact-form-section {
    padding: 120px 0;
    background: $bg-white;

    .section-header {
      margin-bottom: 4rem;

      .section-title {
        font-size: 3.5rem;
        font-weight: 700;
        color: $primary-color;
        margin-bottom: 1.5rem;
        letter-spacing: -0.5px;
        line-height: 1.2;
      }
    }
  }
  
  // CTA Section
  .cta-section {
    padding: 120px 0;
    background: linear-gradient(180deg, $bg-white 0%, $bg-light 50%, $bg-white 100%);
    
    .cta-content {
      .cta-title {
        font-size: 3.5rem;
        font-weight: 700;
        color: $primary-color;
        margin-bottom: 1.5rem;
        letter-spacing: -0.5px;
        line-height: 1.2;
      }
      
      .cta-subtitle {
        font-size: 1.4rem;
        color: $text-medium;
        margin-bottom: 3rem;
        line-height: 1.8;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
      }
      
      .cta-buttons {
        display: flex;
        gap: 1.5rem;
        justify-content: center;
        flex-wrap: wrap;
        
        .btn {
          padding: 20px 45px;
          font-size: 1.2rem;
          font-weight: 700;
          border-radius: 50px;
          text-decoration: none;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          letter-spacing: 0.5px;
          
          &.btn-cta-primary {
            background: $primary-gradient;
            color: white;
            box-shadow: 0 12px 35px rgba(45, 106, 110, 0.4);
            border: 3px solid transparent;
            
            &:hover {
              transform: translateY(-4px);
              box-shadow: 0 18px 45px rgba(45, 106, 110, 0.5);
              background: linear-gradient(135deg, $primary-dark 0%, $primary-color 100%);
            }
          }
          
          &.btn-cta-secondary {
            background: $bg-white;
            color: $primary-color;
            border: 3px solid $primary-color;
            
            &:hover {
              background: $primary-color;
              color: white;
              transform: translateY(-4px);
              box-shadow: 0 12px 35px rgba(45, 106, 110, 0.3);
            }
          }
        }
      }
    }
  }
  
  // Service Area Section
  .service-area-section {
    padding: 120px 0;
    background: $bg-white;
    
    .section-header {
      margin-bottom: 4rem;
      
      .section-title {
        font-size: 2.5rem;
        font-weight: 700;
        color: $primary-color;
        margin-bottom: 1.5rem;
        letter-spacing: -0.5px;
        line-height: 1.2;
      }
      
      .section-subtitle {
        font-size: 1.3rem;
        color: $text-medium;
        max-width: 700px;
        margin: 0 auto;
        line-height: 1.7;
      }
    }
    
    .location-card {
      background: $bg-white;
      border-radius: 20px;
      padding: 2.5rem;
      box-shadow: 0 8px 30px rgba(45, 106, 110, 0.1);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      border: 3px solid $border-light;
      height: 100%;
      display: flex;
      flex-direction: column;
      
      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 45px rgba(45, 106, 110, 0.2);
        border-color: $primary-color;
      }
      
      .location-header {
        margin-bottom: 1.5rem;
        padding-bottom: 1.5rem;
        border-bottom: 3px solid $bg-light;
        
        .location-name {
          font-size: 1.8rem;
          font-weight: 700;
          color: $primary-color;
          margin: 0;
          letter-spacing: -0.3px;
        }
      }
      
      .location-details {
        flex: 1;
        margin-bottom: 1.5rem;
        
        .location-detail-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          margin-bottom: 1.25rem;
          
          &:last-child {
            margin-bottom: 0;
          }
          
          .location-icon {
            color: $primary-color;
            font-size: 1.1rem;
            margin-top: 0.2rem;
            flex-shrink: 0;
            width: 20px;
            text-align: center;
          }
          
          .location-text {
            font-size: 1rem;
            color: $text-dark;
            line-height: 1.6;
            flex: 1;
          }
          
          .location-link {
            font-size: 1rem;
            color: $primary-color;
            text-decoration: none;
            transition: all 0.3s ease;
            line-height: 1.6;
            
            &:hover {
              color: $primary-dark;
              text-decoration: underline;
            }
          }
        }
      }
      
      .location-actions {
        padding-top: 1.5rem;
        border-top: 3px solid $bg-light;
        
        .btn-location-directions {
          width: 100%;
          background: $primary-gradient;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 14px 24px;
          font-size: 1.1rem;
          font-weight: 600;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 8px 25px rgba(45, 106, 110, 0.3);
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          letter-spacing: 0.3px;
          
          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 12px 35px rgba(45, 106, 110, 0.4);
            background: linear-gradient(135deg, $primary-dark 0%, $primary-color 100%);
            color: white;
            text-decoration: none;
          }
          
          &:active {
            transform: translateY(-1px);
          }
          
          i {
            font-size: 1rem;
          }
        }
      }
    }
  }
  
  // Responsive
  @media (max-width: 991px) {
    .contact-hero-section {
      padding: 120px 0 80px;
      
      .hero-content {
        padding-right: 20px;
        
        .hero-title {
          font-size: 3rem;
        }
        
        .hero-subtitle {
          font-size: 2rem;
        }
        
        .hero-description {
          font-size: 1.2rem;
        }
      }
    }
    
    .contact-details-section {
      padding: 80px 0;
    }
    
    .contact-form-section {
      padding: 100px 0;

      .section-header .section-title {
        font-size: 2.5rem;
      }
    }
    
    .cta-section {
      .cta-content {
        .cta-title {
          font-size: 2.5rem;
        }
        
        .cta-subtitle {
          font-size: 1.2rem;
        }
        
        .cta-buttons {
          flex-direction: column;
          
          .btn {
            width: 100%;
          }
        }
      }
    }
    
    .service-area-section {
      padding: 100px 0;
      
      .section-header .section-title {
        font-size: 2.5rem;
      }
      
      .location-card {
        padding: 2rem 1.5rem;
        
        .location-header .location-name {
          font-size: 1.5rem;
        }
        
        .location-details .location-detail-item {
          .location-text,
          .location-link {
            font-size: 0.95rem;
          }
        }
      }
    }
    
  }
  
  @media (max-width: 768px) {
    .contact-hero-section {
      padding: 100px 24px 80px;
      min-height: 380px;

      .hero-content {
        padding-right: 0;
        max-width: 100%;
        
        .hero-title {
          font-size: 2.5rem;
        }
        
        .hero-subtitle {
          font-size: 1.75rem;
        }
        
        .hero-description {
          font-size: 1.1rem;
        }
      }
    }
    
    .contact-details-section {
      padding: 60px 0;
      
      .contact-detail-card {
        padding: 2.5rem 2rem;
        
        .contact-icon {
          width: 90px;
          height: 90px;
          
          i {
            font-size: 2.2rem;
          }
        }
        
        .contact-label {
          font-size: 1.2rem;
        }
        
        .contact-value {
          font-size: 1.1rem;
        }
      }
    }
    
    .contact-form-section {
      padding: 80px 0;

      .section-header .section-title {
        font-size: 2rem;
      }
    }
    
    
    .cta-section {
      padding: 100px 0;
      
      .cta-content {
        .cta-title {
          font-size: 2rem;
        }
        
        .cta-subtitle {
          font-size: 1.1rem;
        }
      }
    }
    
    .service-area-section {
      padding: 80px 0;
      
      .section-header {
        margin-bottom: 3rem;
        
        .section-title {
          font-size: 2rem;
        }
        
        .section-subtitle {
          font-size: 1.1rem;
        }
      }
      
      .location-card {
        padding: 2rem 1.5rem;
        
        .location-header {
          margin-bottom: 1.25rem;
          padding-bottom: 1.25rem;
          
          .location-name {
            font-size: 1.4rem;
          }
        }
        
        .location-details {
          margin-bottom: 1.25rem;
          
          .location-detail-item {
            margin-bottom: 1rem;
            
            .location-icon {
              font-size: 1rem;
            }
            
            .location-text,
            .location-link {
              font-size: 0.9rem;
            }
          }
        }
        
        .location-actions {
          padding-top: 1.25rem;
          
          .btn-location-directions {
            padding: 12px 20px;
            font-size: 1rem;
          }
        }
      }
    }
    
  }
}
</style>

